// frontend/src/components/common/ContactSupportButton.jsx
//
// A button that opens the in-app support form (ContactSupportModal). Screens
// that tell the merchant to contact support use it instead of a mail address.
// Its label is the form's name (`contact.title`), so every screen and the
// help menu say "Contact support" in the same words in every language.

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import ContactSupportModal from './ContactSupportModal';
import './ContactSupportButton.css';

/**
 * @param {'outlined'|'contained'} [variant]  a button next to other buttons
 *   (a popup's button bar); without it, a link inside a sentence
 */
export default function ContactSupportButton({ variant = null }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const show = () => setOpen(true);
  return (
    <>
      {variant ? (
        <Button variant={variant} onClick={show}>{t('contact.title')}</Button>
      ) : (
        <button type="button" className="contact-support-link" onClick={show}>
          {t('contact.title')}
        </button>
      )}
      <ContactSupportModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
